import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Videoplayer from "../Pages/Videoplayer";
import { Helmet } from "react-helmet";

const tabs = [
  {
    id: "media-coverage",
    label: "Media Coverage",
    items: [
      {
        image: "assets/img/media1.jpg",
        title: "BlackOpal to fund real estate projects through NBFC, AIF",
        links: [
          {
            label: "Know More",
            url: "https://economictimes.indiatimes.com/tech/tech-bytes/blackopal-to-fund-real-estate-projects-through-nbfc-aif/articleshow/80975719.cms",
          },
        ],
      },
      {
        image: "assets/img/media3.jpg",
        title: "Budget 2021 Reactions Live Updates - Prasoon Chauhan",
        links: [
          {
            label: "Know More",
            url: "https://www.zeebiz.com/india/news-budget-2021-reactions-live-who-said-what-about-nirmala-sitharamans-announcements-top-quotes-from-india-inc-148147",
          },
        ],
      },
      {
        image: "assets/img/media4.jpg",
        title: "Pre-Budget Quote for Real Estate Sector - Prasoon Chauhan",
        links: [
          {
            label: "Know More",
            url: "https://www.apnnews.com/pre-budget-quote-for-real-estate-sector-prasoon-chauhan-founder-ceo-blackopal/",
          },
        ],
      },
      {
        image: "assets/img/media5.jpg",
        title: "Deduct EMI from 70% RERA Account - Prasoon Chauhan",
        links: [
          {
            label: "Know More",
            url: "https://realty.economictimes.indiatimes.com/news/industry/up-rera-seeks-direction-from-state-government-to-end-flats-registration-deadlock/82287952",
          },
        ],
      },
      {
        image: "assets/img/media6.jpg",
        title: "IIFL Securities - Prasoon Chauhan",
        links: [
          {
            label: "Know More",
            url: "https://www.equitybulls.com/category.php?id=282178",
          },
        ],
      },
    ],
  },
  {
    id: "joint-venture",
    label: "Joint Venture",
    items: [
      {
        image: "assets/img/media/joint_venture.jpg",
        title:
          "Gulshan Group & Ourika Estates joint venture to invest Rs 750 cr on housing projects",
        links: [
          {
            label: "Economic Times",
            url: "https://economictimes.indiatimes.com/markets/digital-real-estate/realty-news/gulshan-group-ourika-estates-to-invest-rs-750-cr-on-2-new-housing-projects/articleshow/134389610.cms?from=mdr",
          },
          {
            label: "ET Realty",
            url: "https://realty.economictimes.indiatimes.com/amp/news/industry/gulshan-group-ourika-estates-to-invest-over-750-crore-in-ghaziabad-lucknow-housing-projects/134387040",
          },
        ],
      },
    ],
  },
  {
    id: "ipo",
    label: "IPO",
    items: [
      {
        image: "assets/img/media/ipo.jpg",
        title: "Black Opal Consultants Limited IPO",
        links: [
          {
            label: "RealtyNMore",
            url: "https://realtynmore.com/black-opal-consultants-limited-set-to-launch-ipo/",
          },
          {
            label: "ET Realty",
            url: "https://realty.economictimes.indiatimes.com/news/allied-industries/black-opal-consultants-55-crore-ipo-to-open-on-september-29/134462295",
          },
        ],
      },
    ],
  },
  {
    id: "shares-list",
    label: "Shares to list on October 7",
    items: [
      {
        image: "assets/img/media/shares_list.jpg",
        title:
          "Black Opal Consultants IPO shares to list on October 7 after 68.71 times subscription",
        links: [
          {
            label: "Moneycontrol",
            url: "https://www.moneycontrol.com/news/business/black-opal-consultants-ipo-shares-to-list-on-october-7-after-68-71-times-subscription-14045042.html",
          },
          {
            label: "Hindu Business Line",
            url: "https://www.thehindubusinessline.com/markets/sensex-nifty50-today-stock-market-highlights-5th-october-2026/article71544056.ece",
          },
        ],
      },
    ],
  },
  {
    id: "share-hit",
    label: "Share Hit",
    items: [
      {
        image: "assets/img/media/share_hit.jpg",
        title:
          "Black Opal Consultants shares hit Rs 210 upper circuit after BSE SME debut",
        links: [
          {
            label: "ANI News",
            url: "https://www.aninews.in/news/business/black-opal-consultants-shares-hit-rs-210-upper-circuit-after-bse-sme-debut-gain-660-over-ipo-price20261008181626/",
          },
          {
            label: "The Print",
            url: "https://theprint.in/ani-press-releases/black-opal-consultants-shares-hit-rs-210-upper-circuit-after-bse-sme-debut-gain-6-60-over-ipo-price/3065812/?amp",
          },
        ],
      },
    ],
  },
  {
    id: "investors-buy",
    label: "Investors Buy",
    items: [
      {
        image: "assets/img/media/investors_buy.jpg",
        title: "Prominent investors buy into newly listed Black Opal",
        links: [
          {
            label: "RealtyNMore",
            url: "https://realtynmore.com/prominent-investors-buy-into-newly-listed-black/",
          },
          {
            label: "Dailyhunt",
            url: "https://m.dailyhunt.in/news/india/english/tycoon+world-epaper-dh4c6a646b987d48f5b87f17d40865f089/max+family+office+through+piveta+estates+and+gaursons+promoters+buys+into+newly+listed+black+opal+consultants+ltd+through+open+market+trans-newsid-dh4c6a646b987d48f5b87f17d40865f089_107c59d0c48711f195ffc220b8d82383?sm=Y",
          },
        ],
      },
    ],
  },
  {
    id: "rera",
    label: "RERA",
    items: [
      {
        image: "assets/img/media/rera.jpg",
        title: "Black Opal Group entity receives RERA approval",
        links: [
          {
            label: "RealtyNMore",
            url: "https://realtynmore.com/black-opal-group-entity-receives-rera-approval-for/",
          },
          {
            label: "Dailyhunt",
            url: "https://m.dailyhunt.in/news/india/english/tycoon+world-epaper-dh4c6a646b987d48f5b87f17d40865f089/black+opal+consultants+group+entity+gets+rera+nod+for+475+crore+housing+project+in+ghaziabad-newsid-dh4c6a646b987d48f5b87f17d40865f089_83eb39f0cbbb11f19ff5a16020a01245?sm=Y",
          },
        ],
      },
    ],
  },
];

const Media = () => {
  const pageTitle = "Media";
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const activeItems = tabs.find((tab) => tab.id === activeTab)?.items || [];

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <div className="main-content">
        <Header />

        <section className="career-wrapper">
          <Videoplayer />
        </section>

        <div className="sec-title2 mb-55 md-mb-35 text-center">
          <div className="sub-text" />
          <h2 className="title mb-0"> </h2>
        </div>

        <div className="row justify-content-center" style={{ marginBottom: 80 }}>
          <div className="col-md-10">
            <div className="w-full mb-3 flex flex-wrap overflow-x-auto gap-2 sm:gap-4 border-b border-gray-200 px-2">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  className={`relative text-sm font-medium px-3 py-2 transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? "!text-[#F26624] !bg-transparent"
                      : "!text-gray-500 hover:text-gray-700 !bg-transparent"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                  {activeTab === tab.id && (
                    <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
                  )}
                </button>
              ))}
            </div>

            <div className="container">
              <div className="row">
                {activeItems.map((item, index) => (
                  <div
                    key={`${activeTab}-${index}`}
                    className="col-lg-4 col-md-6 mb-30"
                  >
                    <div className="project-item">
                      <div className="project-img">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="gallery-img media-border"
                        />
                      </div>
                      <div
                        style={{
                          fontSize: 15,
                          color: "#F26624",
                          marginTop: "-10px",
                          marginBottom: "8px",
                        }}
                      >
                        News
                      </div>
                      <span className="articleSummary-infoDate">
                        {item.title}
                      </span>
                      <br />
                      <div
                        style={{
                          marginTop: 8,
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px 16px",
                        }}
                      >
                        {item.links.map((linkItem) => (
                          <span
                            key={linkItem.url}
                            style={{ fontSize: 12, color: "#F26624" }}
                          >
                            <a
                              href={linkItem.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {linkItem.label}
                            </a>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Media;
